function initFeaturedSlider(slider) {
  if (!slider) return;

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 4,
    gap: '3rem',
    pagination: false,
    arrows: false,
    breakpoints: {
      1024: { perPage: 3 },
      768: { perPage: 2 },
      480: { perPage: 1 },
    },
  });

  const bar = slider.querySelector('.my-carousel-progress-bar');

  splide.on('move', function () {
    const end = splide.Components.Controller.getEnd() + 1;
    const rate = Math.min((splide.index + 1) / end, 1);
    bar.style.width = `${rate * 100}%`;
  });

  splide.mount();

  const prevBtn = slider.querySelector('.splide__arrow--prev');
  const nextBtn = slider.querySelector('.splide__arrow--next');

  if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
  if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));
}

function autoInitSliders() {
  const sliders = document.querySelectorAll('.fps-splide');
  sliders.forEach((slider) => initFeaturedSlider(slider));
}

autoInitSliders();

document.addEventListener('shopify:section:load', () => {
  autoInitSliders();
});

document.addEventListener('shopify:section:select', () => {
  autoInitSliders();
});
